import React from 'react';
import {authRole} from '../../shared/constants/AppConst';
//Route config for eRx details
export const dischargeSummaryConfig = [
  {
    auth: authRole.user,
    routes: [
      {
        path: '/dischargeSummary',
        component: React.lazy(() => import('./DischargeSummaryList')),
      },
    ],
  },
];
